// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G6jnY","img":"styles_img__20tNQ","titleContainer":"styles_titleContainer__Bqh7k","title":"styles_title__deY2t"};